import { ajax } from 'cadenza/api-client/api';
import { MIMETYPE_DISY_FEATURES_WITH_ATTACHMENTS } from 'cadenza/api-client/api-constants';
import type { DimensionDto } from 'cadenza/api-client/dto/dimension-dto';
import type { WorldBoxDto } from 'cadenza/api-client/dto/world-box-dto';

/** @see net/disy/cadenza/gis/web/layer/attachments/geojson/Attachment.java */
interface Attachment {
  url: string;
  thumbnailUrl: string;
  name: string;
  mimeType: string;
}

/** @see net/disy/cadenza/gis/web/layer/attachments/rest/AttachmentEndpointController.java */
export class LayerAttachmentsApi {

  readonly layerId: string;

  constructor (layerId: string) {
    this.layerId = layerId;
  }

  getFeaturesWithAttachments (extent: WorldBoxDto, [ width, height ]: DimensionDto, srs: string, ...attachmentTypes: string[]) {
    const data = {
      bbox: extent.join(),
      width,
      height,
      srs,
      attachmentTypes: attachmentTypes.join()
    };
    const headers = { Accept: MIMETYPE_DISY_FEATURES_WITH_ATTACHMENTS };
    return ajax(`/layers/${this.layerId}/features`, { data, headers });
  }

  getAttachments (featureId: string) {
    return ajax<Attachment>(`/layers/${this.layerId}/features/${featureId}/attachments`);
  }

}
